<template>
  <v-container fluid>
    <validation-observer v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" md="12">
              <basic-info-consultar-bpr
                id="basic-info-consultar"
                ref="basicInfoConsultar"
                :dataUltimoIpcaOficial="dataUltimoIpcaOficial"
                :dataUltimoIpcaNaoOficial="dataUltimoIpcaNaoOficial"
                :mesesSemAtualizarIpcaOficial="mesesSemAtualizarIpcaOficial"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" />
        <v-col cols="12" md="6">
          <v-btn
            :loading="loading"
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            @click="consultar()"
            :disabled="invalid"
          >
            Consultar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import BprService from "@/services/BprService";
import AtualizacaoIndicesService from "@/services/AtualizacaoIndicesService";
import dayjs from 'dayjs';

export default {

  components: {
    BasicInfoConsultarBpr: () => import('@/components/bpr/BasicInfoConsultarBpr')
  },

  mounted() {
    this.getUltimoIpca();
  },

  data: () => ({
    dataUltimoIpcaOficial: '',
    dataUltimoIpcaNaoOficial: '',
    mesesSemAtualizarIpcaOficial: 0,
    loading: false
  }),

  methods: {
    getUltimoIpca() {
      AtualizacaoIndicesService.getUltimoIndiceIpca().then((indice) => {
        this.dataUltimoIpcaOficial = indice.indice_oficial ? indice.indice_oficial.DataRegistro : '';
        this.dataUltimoIpcaNaoOficial = indice.indice_estimado ? indice.indice_estimado.DataRegistro : '';

        let dataAtual = dayjs();
        let qtdMeses = dataAtual.diff((dayjs(this.dataUltimoIpcaOficial)), 'month');
        this.mesesSemAtualizarIpcaOficial = qtdMeses;
      })
      .catch(() => this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', { position: 'topRight' }));
    },

    consultar() {
      let objDatasCodigos = { ...this.$refs.basicInfoConsultar.exportData() };

      if (objDatasCodigos.dataRegistro != '-01' && objDatasCodigos.codigos != "") {
        this.loading = true;

        BprService.consultar(objDatasCodigos)
          .then(response => {
            this.$toast.info('Preparando seu arquivo para download.', '',{position:'topRight', timeout: 3000});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            let nomeArquivo = this.getNomeArquivo(objDatasCodigos.dataRegistro);
            link.setAttribute("download", nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            let message = "Erro ao gerar arquivo xlsx com o resultado BPR.";

            if (typeof error.response !== 'undefined') {
              message = error.response.data.erro != "Erro: A data de referência está incorreta, confira o ultimo IPCA." ? message : error.response.data.erro;
              console.error(error.response.data.erro);
            } else {
              console.error(error);
            }

            this.$toast.error(message, '',{position:'topRight'});
          })
          .finally(() => this.loading = false);
      } else {
        this.$toast.error('Preencha todos os campos.','',{position: 'topRight'});
      }
    },

    getNomeArquivo(dateSql) {
      let monthYearSqlToPt = dateSql.slice(0, -3).split('-');
      monthYearSqlToPt = monthYearSqlToPt[1]+'_'+monthYearSqlToPt[0];
      return 'modulos_aneel_mcpse_grupo_'+monthYearSqlToPt+'.xlsx';
    }
  }
}

</script>